/**
 * For a variance swap specifies how PaymentStreamLinkStrikePrice(42673) is expressed.
 * tag: 42674
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamLinkStrikePriceType {
  /** Volatility */
  Volatility = 0,
  /** Variance */
  Variance = 1,
}
